import React, { useState, useEffect, useRef } from 'react';
import './HalloweenDiceBonus.css';

const HalloweenDiceBonus = ({ onBonusRoundCompleted, gameResult }) => {
    const [selectedDice, setSelectedDice] = useState(null);
    const [prize, setPrize] = useState(309);
    const [multipliedPrize, setMultipliedPrize] = useState(309);
    const [isAnimating, setIsAnimating] = useState(false);
    const [currentFrame, setCurrentFrame] = useState(0);
    const [showGif, setShowGif] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const bgAudioRef = useRef(null);

    const diceValues = [1, 2, 6, 4, 5];

    // Play background music when the bonus opens, stop it when it closes
    useEffect(() => {
        const bgAudio = new Audio('./assets/dice-bg.ogg');
        bgAudio.loop = true;
        bgAudio.play().catch(e => console.log("Background audio play error", e));
        bgAudioRef.current = bgAudio;

        return () => {
            bgAudio.pause();
            bgAudio.currentTime = 0;
            bgAudioRef.current = null;
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isAnimating) {
                setCurrentFrame((prev) => (prev < 79 ? prev + 1 : 0));
            }
        }, 60); // Increased from 30ms to 60ms to reduce CPU usage

        return () => clearInterval(interval);
    }, [isAnimating]);

    const handleDiceClick = (index, value) => {
        if (selectedDice !== null || isAnimating) return;

        const diceAudio = new Audio('./assets/bonus-dice.mp3');
        diceAudio.play().catch(e => console.log("Audio play error", e));

        setSelectedDice(index);
        setIsAnimating(true);
        setShowGif(true);

        // After 1.3 seconds (like in original code), move down and show result
        setTimeout(() => {
            setShowGif(false);
            setShowResult(true);
            const newPrize = prize * value;
            setMultipliedPrize(newPrize);

            setTimeout(() => {
                setIsAnimating(false);
                if (onBonusRoundCompleted) {
                    onBonusRoundCompleted(newPrize);
                }
            }, 2000);
        }, 1300);
    };

    return (
        <div className="h-100 w-100 position-relative">
            <img className="h-100 w-100" src="assets/img/DIceBonus/bg.png" alt="Background" />
            <div className="halloween-dice-bonus-container px-0">
                <div className="cauldron-content bg-transparent">
                    <div className="cauldron-inner-content">
                        <div className="text-center" style={{ height: "20%" }}>
                            <img className="w-100 h-100 " src="./assets/img/DIceBonus/bomba-bonus-header-bar.png" alt="Header" />
                        </div>

                        <div className="dice-display-area">
                            <div className="dice-row">
                                {diceValues.map((value, index) => {
                                    const frameSrc = `./assets/img/DIceBonus/(${currentFrame}).webp`;
                                    const isSelected = selectedDice === index;

                                    const transforms = [
                                        'none',
                                        'rotate(90deg)',
                                        'scaleX(-1)',
                                        'scaleY(-1)',
                                        'rotate(45deg) scaleX(-1)'
                                    ];

                                    return (
                                        <div
                                            key={index}
                                            className={`dice-box ${isSelected ? 'selected' : ''} ${showResult && isSelected ? 'fallen' : ''} ${selectedDice !== null && !isSelected ? 'dimmed' : ''}`}
                                            onClick={() => handleDiceClick(index, value)}
                                        >
                                            {/* Rolling Animation Sequence */}
                                            <img
                                                src={frameSrc}
                                                alt="Dice Animation"
                                                className={`dice-image ${isSelected ? 'd-none' : ''}`}
                                                style={{ transform: transforms[index] }}
                                            />

                                            {/* Rolling GIF (Toggled with class) */}
                                            <img
                                                src={`assets/img/DIceBonus/dice.gif?v=${index}`}
                                                alt="Dice Rolling GIF"
                                                className={`dice-gif ${isSelected && showGif ? '' : 'd-none'}`}
                                            />

                                            {/* Final Result (Using actual images instead of CSS) */}
                                            <img
                                                src={`./assets/img/DIceBonus/dice-${value}.png`}
                                                alt={`Dice ${value}`}
                                                className={`dice-result-image ${isSelected && showResult ? '' : 'd-none'}`}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="halloween-footer">
                    <div className="footer-content">
                        <div className="instruction-text">
                            Escolha o dado para<br />
                            <span className="highlight">MULTIPLICAR</span> seu Prêmio
                        </div>
                        <div className="d-flex flex-column">
                            <span className='text-content text-3d'>Premio</span>
                            <span className='Premio-btn position-relative'>
                                <img className='img-fluid' src="assets/img/premio-btn-img.png" alt="" />
                                <span className='btn-text-content'>  {multipliedPrize}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HalloweenDiceBonus;
